/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import parse from 'html-react-parser'
import { FC, ReactElement, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router'

import { BigPulseLoader } from '../../components/loaders'
import Page from '../../components/page'
import { openSnackbar } from '../../components/snackbar'
import { useI18n } from '../../hooks'
import { isIE } from '../../utils'

const Vendor: FC = (): ReactElement => {
  const [head, setHead] = useState<string>('')
  const [body, setBody] = useState<string>('')
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const { t } = useI18n()

  const removeLoader = useCallback(() => setTimeout(() => setIsLoaded(true), 300), [])

  const fetchHead = useCallback(
    async (vendor: string) => {
      try {
        const { data: headHtml } = await axios.get(`/vendorPages/${vendor}/head.html`)
        if (headHtml) {
          setHead(headHtml as string)
        } else {
          openSnackbar(t('Vendor_errorMessage'), 15, 'topLeft', 'failure')
        }
      } catch (e) {
        console.error(e)
        openSnackbar(t('Vendor_errorMessage'), 15, 'topLeft', 'failure')
      }
    },
    [t]
  )

  const fetchBody = useCallback(
    async (vendor: string) => {
      try {
        const { data: bodyHtml } = await axios.get(`/vendorPages/${vendor}/body.html`)
        if (bodyHtml) {
          setBody(bodyHtml as string)
        } else {
          openSnackbar(t('Vendor_errorMessage'), 15, 'topLeft', 'failure')
        }
      } catch (e) {
        console.error(e)
        openSnackbar(t('Vendor_errorMessage'), 15, 'topLeft', 'failure')
      }
    },
    [t]
  )

  const params: { vendor: string } = useParams()
  useEffect(() => {
    if (params.vendor && !head) {
      Promise.all([fetchHead(params.vendor)])
    }
  }, [params.vendor, head])

  useEffect(() => {
    if (params.vendor && head) {
      Promise.all([fetchBody(params.vendor)])
    }
  }, [head, params.vendor])

  useEffect(() => {
    if (head && body) {
      removeLoader()
    }

    return () => clearInterval(removeLoader())
  }, [head, body, removeLoader])

  const headContent = (head: string) =>
    !isIE() ? (
      <Helmet>
        <>{parse(head || '')}</>
      </Helmet>
    ) : (
      <head>{parse(head || '')}</head>
    )

  return (
    <Page metaData={{ title: '', description: '', charset: 'utf-8' }} className="homepage">
      {headContent(head)}
      <>
        {parse(body || '', {
          replace: (domNode) => {
            if (domNode.type === 'script') {
              const script = document.createElement('script')
              //@ts-ignore
              const src = domNode.attribs.src
              if (src) {
                script.src = src
                //have to have an onload attribute in order to work
                script.onload = () => console.log('script loaded')
                const inDocument = Array.from(document.querySelectorAll('script'))
                const isScriptInDocument = inDocument.filter((script) => (script as HTMLElement).getAttribute('src') === src).length
                if (!isScriptInDocument) document.body.appendChild(script)
              }
            }
          },
        })}
        {!isLoaded && <BigPulseLoader style={{ zIndex: '999' }} noFade={true} />}
      </>
    </Page>
  )
}

export default Vendor
